import { ErrorData } from '@ddt-web/data-service';

/**
 * OutputResult: result of the condition evaluator.
 * @property {any} output output from condition.
 * @property {ErrorData} error error from extractor if any.
 */
export class OutputResult {
	constructor(public output: any, public error?: ErrorData) {}
}
